import { NgRedux } from '@ptl/angular-redux-store';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { StateStructure } from '@ptl/state';
import { Subscription } from 'rxjs';
import { resetSort, setSortBy } from './configs/plan-sort-by-attribute.reducer';

interface Sort { displayContent: string, value: string };
interface PlanSortByAttributeControls {
  sortBy: AbstractControl;
}
interface PlanSortByAttributeAsJson {
  sortBy: Sort;
}

@Component({
    selector: 'app-plan-sort-by-attribute',
    templateUrl: './plan-sort-by-attribute.component.html',
    styleUrls: ['./plan-sort-by-attribute.component.scss'],
    standalone: false
})
export class PlanSortByAttributeComponent implements OnInit, OnDestroy {

  @Input() sortByHeader: string;

  form: UntypedFormGroup;
  formChanges: Subscription;

  sorts: Sort[] = [
    { value: 'premium-low-to-high', displayContent: 'Premium Low-to-High' },
    { value: 'premium-high-to-low', displayContent: 'Premium High-to-Low' },
    // { value: 'plan-name', displayContent: 'Plan Name' },
    { value: 'deductible-low-to-high', displayContent: 'Deductible Low-to-High' },
    { value: 'deductible-high-to-low', displayContent: 'Deductible High-to-Low' },
    { value: 'reset', displayContent: 'All Plans' }
  ];

  constructor(
    private fb: UntypedFormBuilder,
    private ngRedux: NgRedux<StateStructure>
  ) { }

  ngOnInit(): void {

    /** Setup form */
    this.form = this.fb.group({
      sortBy: this.fb.control(null)
    });

    /** Reset filter */
    this.formControls.sortBy.setValue(this.sorts[this.sorts.length - 1]);

    /** Observe changes */
    this.formChanges = this.form.valueChanges.subscribe((formValues: PlanSortByAttributeAsJson) => {
      if (formValues.sortBy.value === 'reset') {
        this.ngRedux.dispatch(resetSort());
      } else {
        this.ngRedux.dispatch(setSortBy(formValues.sortBy.value));
      }
    });
  }

  ngOnDestroy(): void {
    if (this.formChanges) {
      this.formChanges.unsubscribe();
    }
  }

  get formControls(): PlanSortByAttributeControls {
    return this.form.controls as unknown as PlanSortByAttributeControls;
  }

  get formValuesAsJson(): PlanSortByAttributeAsJson {
    return this.form.value as unknown as PlanSortByAttributeAsJson;
  }


}
